<template>
    <div class="modal fade" id="sideMenuModal" tabindex="-1" aria-hidden="true"
        style="height: 100% !important;z-index:10002;border-radius:0px !important">
        <div class="modal-dialog modal-fullscreen">
            <div class="modal-content">
                <hr class="m-0" />
                <div class="modal-body ">
                    <div class="d-flex justify-content-between">
                        <button type="button" class="btn" data-bs-dismiss="modal" id="sideMenuModalCloseBTN" >
                            <i class="bi  bi-x"></i>
                        </button>
                        <h2 class="text-end" style="color: red;font-size: 22px;font-family: Adera!important;">RADAP</h2>
                    </div>
                    <!-- پاپ اپ وقتی وارد نشده باشد -->
                    <ul class="list-group list-group-flush" v-if="!auth.login">
                        <li class="list-group-item" @click="goFollow(1)">ثبت نام</li>
                        <li class="list-group-item" @click="goFollow(2)">ورود به حساب کاربری</li>
                        <li class="list-group-item">
                            <a class="text-dark" href="https://rubika.ir/RAADAPP">
                            پشتیبانی آنلاین 
                            </a>
                        </li>
                        <li class="list-group-item" @click="goBenefitPage">کسب درآمد</li>
                    </ul>

                    <!-- پاپ اپ وقتی وارد شده باشد -->
                    <ul class="list-group list-group-flush" v-else>
                        <li class="list-group-item">
                            <div @click="goFollow(3)">
                                <i class="bi bi-user ml-1"></i>{{ auth.profile.name }} {{ auth.profile.family}}
                            </div>
                        </li>
                        <li class="list-group-item" @click="goFollow(3)">تنظیمات</li>
                        <li class="list-group-item"> 
                            <a class="text-dark" href="https://rubika.ir/RAADAPP">
                            پشتیبانی آنلاین 
                            </a>
                        </li>
                        <li class="list-group-item" @click="goBenefitPage">کسب درآمد</li>
                        <li class="list-group-item" @click="goAboutPage">درباره ما</li>
                        <li class="list-group-item" @click="goContactPage">تماس با ما</li>
                        <li class="list-group-item text-danger" @click="exitAccount">خروج از حساب کاربری</li>
                    </ul>

                    <div class="position-fixed bottom-0 right-0 w-100">
                        <div class="bg-light text-center w-100 p-2" style="font-family: 'IranSans';">راداَپ در شبکه های اجتماعی</div>
                        <div class=" d-flex justify-content-around align-items-center w-100 my-2">
                                <a target="_blank" href="https://instagram.com/radap_ir?igshid=MGNiNDI5ZTU=" >
                                    <img src="../../../assets/img/instagram.png" width="25" height="25">
                                </a>
                                <a target="_blank" href="https://wa.me/09928728971">
                                    <img src="../../../assets/img/whatsapp.png" width="27" height="27">
                                </a>
                                <a target="_blank" href="https://t.me/online_rad_groups">
                                        <img src="../../../assets/img/telegram.png" width="27" height="27">
                                </a>
                                <a target="_blank" href="https://rubika.ir/RAADAPP" >
                                        <img src="../../../assets/img/rubica.png" width="30" height="30">
                                </a>
                            </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { useRouter } from "vue-router";
import { ref } from '@vue/reactivity'
import { onMounted } from "vue";
import { useAuth } from '@/store/auth'
let auth = useAuth()
let router = useRouter();
let signSideMenuFlag = ref(false)
let fullName = ref('')

function goBenefitPage() {
    document.getElementById('sideMenuModalCloseBTN').click()
    router.push({ name: 'Benefit' })
}
function goAboutPage() {
    document.getElementById('sideMenuModalCloseBTN').click()
    router.push({ name: 'About' })
}
function goContactPage() {
    document.getElementById('sideMenuModalCloseBTN').click()
    router.push({ name: 'Contact' })
}
function goFollow(type) {
    if (type == 1) {
        document.querySelector('#mobileModalBTN').click()
    } else if (type == 2) {
        document.querySelector('#loginsModalBTN').click()
    } else if (type == 3) {
        document.querySelector('#sideMenuModalCloseBTN').click()
        router.push({ name: 'Account',hash:'#profile' })

    }
}
function exitAccount() {
    localStorage.removeItem("token");
    localStorage.removeItem("basket");
    window.location.href = 'https://radap.ir'
}
function nightMode(mode) {

    if (mode == 'moon') {
        document.querySelector('.fa-sun-o').style.display = 'block'
        document.querySelector('.fa-moon-o').style.display = 'none'
        let arr = document.getElementsByTagName('*')
        for (let i = 0; i < arr.length; i++) {
            arr[i].style.backgroundColor = '#16171d'
            arr[i].style.color = 'white'

        }
    } else {
        document.querySelector('.fa-sun-o').style.display = 'none'
        document.querySelector('.fa-moon-o').style.display = 'block'
        let arr = document.getElementsByTagName('*')
        for (let i = 0; i < arr.length; i++) {
            arr[i].style.backgroundColor = 'white'
            arr[i].style.color = 'black'
        }
    }
}

</script>

<style >
/* *{
    background-color: #16171d !important;
    color:#fff !important;
} */
.btn-close {
    color: red;
    /* top: 10px;
    position: fixed; */
}
</style>